export default (date) => Math.floor(date.getTime() / 1000);



// WEBPACK FOOTER //
// ./~/jose/dist/browser/lib/epoch.js